import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { c_dialog_share_incident_report_email_component } from './c_dialog_share_incident_report_email_component';
import { WarningModule } from '../../../../app/modals/warning/warning.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SharedModule } from '../../../../app/directives/shared.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    WarningModule,
    SharedModule
  ],
  declarations: [c_dialog_share_incident_report_email_component],
})
export class c_dialog_share_incident_report_email_module { }
